module.exports = __webpack_public_path__ + "img/logo-white.92f86959.png";